import { UserRole } from './core';

/**
 * Hybrid Clerk org model: PM/admin/platform operators and self-managing owners must have an active
 * Clerk organization session in the app (OperatorOrgGate / OrgSelectionView).
 */
export function requiresOperatorClerkOrg(userRole: UserRole, isSelfManagingOwner: boolean): boolean {
  if (userRole === UserRole.OWNER && isSelfManagingOwner) return true;
  return (
    userRole === UserRole.PROPERTY_MANAGER ||
    userRole === UserRole.ADMIN ||
    userRole === UserRole.PLATFORM_ADMIN ||
    userRole === UserRole.SYSTEM_ADMIN
  );
}

/**
 * Demo/TestDB Clerk sync: `/demo` picker personas that need `DEMO_CLERK_OPERATOR_ORG_ID` membership.
 * Excludes platform ADMIN (not on demo picker; saves Clerk org quota). Runtime org gates still use
 * {@link requiresOperatorClerkOrg} (includes ADMIN for credentialed platform operators).
 */
export function requiresDemoClerkOrgMembership(userRole: UserRole, isSelfManagingOwner: boolean): boolean {
  if (userRole === UserRole.PROPERTY_MANAGER) return true;
  if (userRole === UserRole.OWNER && isSelfManagingOwner) return true;
  switch (userRole) {
    case UserRole.OWNER:
      return !isSelfManagingOwner;
    case UserRole.TENANT:
    case UserRole.VENDOR:
    case UserRole.INVESTOR:
      return true;
    default:
      return false;
  }
}
